module.exports = __webpack_public_path__ + "static/media/nrd-Y9oI7oLSd_c-unsplash.37040f2c.jpg";